var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgC2COrder = function SvgC2COrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77 8.544 5.698 6.44h-1.86V3.9H9V2.2H3.637a1.5 1.5 0 0 0-1.5 1.5v4.52a.4.4 0 0 0 .634.324ZM17.366 11.456 14.44 13.56h1.86v2.54h-5.163v1.7H16.5a1.5 1.5 0 0 0 1.5-1.5v-4.52a.4.4 0 0 0-.634-.324Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 9)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeWidth: 1.7,
    cx: 3.5,
    cy: 3.5,
    r: 2.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6a3.502 3.502 0 0 1 3.363 2.526H5.014a1.799 1.799 0 0 0-3.028 0H.137A3.502 3.502 0 0 1 3.5 6Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeWidth: 1.7,
    cx: 3.5,
    cy: 3.5,
    r: 2.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6a3.502 3.502 0 0 1 3.363 2.526H5.014a1.799 1.799 0 0 0-3.028 0H.137A3.502 3.502 0 0 1 3.5 6Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))));
};
export default SvgC2COrder;